import { useState, type FormEvent } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { LoginBody } from "@alpha/shared";
import { authClient } from "../auth";

export function LoginPage() {
  const { data: session } = authClient.useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const from = (location.state as { from?: string } | null)?.from ?? "/";

  if (session) return <Navigate to={from} replace />;

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    const form = new FormData(e.currentTarget);
    const parsed = LoginBody.safeParse({ email: form.get("email"), password: form.get("password") });
    if (!parsed.success) {
      setError("Enter a valid email and password.");
      return;
    }
    setBusy(true);
    const res = await authClient.signIn.email(parsed.data);
    setBusy(false);
    if (res.error) {
      // Same message for every failure, so the form never reveals whether an account exists.
      setError(res.error.status === 429 ? "Too many attempts. Try again later." : "Invalid email or password.");
      return;
    }
    navigate(from, { replace: true });
  }

  return (
    <main className="login">
      <form onSubmit={onSubmit} noValidate>
        <h1>Alpha Terminal</h1>
        <label>
          Email
          <input name="email" type="email" autoComplete="username" required />
        </label>
        <label>
          Password
          <input name="password" type="password" autoComplete="current-password" required />
        </label>
        {error && (
          <p role="alert" className="error">
            {error}
          </p>
        )}
        <button type="submit" disabled={busy}>
          {busy ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </main>
  );
}
